import { rankingItems } from '@/mocks/home';

const trendIcons: Record<string, string> = {
  up: 'ri-arrow-up-line',
  stable: 'ri-subtract-line',
  down: 'ri-arrow-down-line',
};

const trendColors: Record<string, string> = {
  up: 'text-primary-600',
  stable: 'text-foreground-500',
  down: 'text-secondary-600',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-8 md:mb-12">
            <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-2">
              人气排行
            </h2>
            <p className="text-sm text-foreground-500">全网漫画热度实时排行，热门作品一网打尽</p>
          </div>

          <div className="max-w-[720px] mx-auto">
            <div className="bg-background-100 rounded-xl border border-background-200/70 overflow-hidden">
              {rankingItems.map((item, index) => (
                <div
                  key={item.id}
                  className={`flex items-center gap-3 md:gap-4 p-3 md:p-4 cursor-pointer hover:bg-background-50 transition-colors ${
                    index < rankingItems.length - 1 ? 'border-b border-background-200/70' : ''
                  }`}
                >
                  <div className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold shrink-0 ${
                    item.rank <= 3
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-200 text-foreground-600'
                  }`}>
                    {item.rank}
                  </div>

                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2">
                      <span className="text-sm font-semibold text-foreground-900">{item.title}</span>
                      <span className={`text-xs ${trendColors[item.trend]}`}>
                        <i className={trendIcons[item.trend]}></i>
                      </span>
                    </div>
                    <div className="flex items-center gap-2 mt-0.5">
                      <span className="text-xs px-1.5 py-0.5 bg-secondary-100 text-secondary-700 rounded font-medium">
                        {item.genre}
                      </span>
                      <span className="text-xs text-foreground-500">{item.chapter}</span>
                    </div>
                  </div>

                  <span className="text-xs font-medium text-foreground-600 whitespace-nowrap shrink-0">
                    {item.heat}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}